module.exports = __webpack_public_path__ + "static/img/tuwenfasong.8a862e82.png";